@use '@design/design-tokens/typography/typography' as *;

.tooltipWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  margin-bottom: 12px;
  cursor: pointer;
  padding: 0;

  &:hover {
    background-color: var(--surface-hover);
  }
}

.rightWrapper {
  display: flex;
  flex-direction: column;
}

.tooltipTitleLabel {
  @include typography-v2-title-sm;
}

.categoryLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}
